import React from 'react';

import { colorsPalette } from '../../theme';

const ExpandIcon = (props) => {
  const color = props?.color || colorsPalette.white;
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M16.4999 9V16.4999H1.50007V1.50007H9V0H1.50007C0.67522 0 0 0.675 0 1.50007V16.5001C0 17.3248 0.67522 18 1.50007 18H16.4999C17.3248 18 18 17.3248 18 16.4999V9H16.4999Z"
          fill={color}
        />
        <path
          d="M17.2501 0H11.9999V1.49963H15.4386L9 7.93912L10.0607 9L16.4999 2.56162V5.99985H18L17.9993 0.749707C18 0.335918 17.6639 0 17.2501 0Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="18" height="18" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ExpandIcon;
